export const uuidv4 = require('uuid/v4');
export const FAILED_TO_FETCH_ERROR = "TypeError: Failed to fetch"
export const INTERNET_CONNECTION_APPEARS_TO_BE_OFFLINE = "TypeError: The Internet connection appears to be offline."
export function createAnId(){
  return "anid_" + uuidv4().replace(/-/g, '');
}
